// extracted by mini-css-extract-plugin
export default {"stats-bar":"stats-bar__TdSZT","item":"item__PVknN","icon":"icon__iZa93","text":"text__qisXG"};